// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleFilledSvg from "@ant-design/icons-svg/es/asn/EyeInvisibleFilled";
import AntdIcon from '../components/AntdIcon';

var EyeInvisibleFilled = function EyeInvisibleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleFilledSvg
  }));
};

EyeInvisibleFilled.displayName = 'EyeInvisibleFilled';
export default React.forwardRef(EyeInvisibleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EyeInvisibleFilled.js
// module id = 1053
// module chunks = 0